import React from "react";
import { HubHookFormInput, HubIcon } from "../../components";
import { useFormContext } from "react-hook-form";

const ResestPasswordFullfilmentFields = ({ isLoading }) => {
  const { getValues } = useFormContext();

  return (
    <>
      <HubHookFormInput
        name="password"
        label="Password"
        placeholder="Enter your new password"
        startAdornment={<HubIcon icon="Lock" size={12} />}
        disabled={isLoading}
        type="password"
        required
      />
      <HubHookFormInput
        name="confirm"
        label="Confirm Password"
        placeholder="Confirm your new password"
        startAdornment={<HubIcon icon="Lock" size={12} />}
        rules={{
          validate: (value) =>
            value === getValues("password") || "Passwords Must Match",
        }}
        disableHelperText={false}
        type="password"
        disabled={isLoading}
        required
      />
    </>
  );
};

export default ResestPasswordFullfilmentFields;
